/** Page builder types for visual step editor */

export type BlockType =
  | 'hero'
  | 'product-offer'
  | 'product-gallery'
  | 'product-specs'
  | 'reviews-widget'
  | 'cta-section'
  | 'cta'
  | 'discount-badge'
  | 'timer'
  | 'countdown'
  | 'testimonial'
  | 'text'
  | 'image'
  | 'image-gallery'
  | 'feature-list'
  | 'video-embed'
  | 'divider'

export type BlockCategory = 'content' | 'commerce' | 'social-proof' | 'media' | 'layout'

export interface BlockConfig {
  type: BlockType
  label: string
  icon: string
  description: string
  category: BlockCategory
  defaultProps: Record<string, string | number | boolean>
}

export interface PageBlock {
  id: string
  type: BlockType
  props: Record<string, string | number | boolean>
}

export type SaveStatus = 'idle' | 'unsaved' | 'saving' | 'saved' | 'error'

export type DevicePreview = 'desktop' | 'tablet' | 'mobile'

/** Tailwind max-width classes for each device preview size */
export const DEVICE_WIDTHS: Record<DevicePreview, string> = {
  desktop: 'max-w-lg',
  tablet: 'max-w-sm',
  mobile: 'max-w-[320px]',
}

export interface BuilderState {
  blocks: PageBlock[]
  selectedBlockId: string | null
  devicePreview: DevicePreview
  showPreview: boolean
  saveStatus: SaveStatus
}

export interface UndoRedoState<T> {
  state: T
  set: (newState: T | ((prev: T) => T)) => void
  reset: (newState: T) => void
  undo: () => void
  redo: () => void
  canUndo: boolean
  canRedo: boolean
}
